import { useEffect, useState } from "react";
import { Form } from "antd";
import { toast } from "react-toastify";
import Modal from "../../Components/Modal/Modal";
import FormBox from "../../Components/Form";
import Button from "../../Components/Button";
import { getKaminSettings, KaminSettings, saveKaminSettings } from "../../Requests/kamin2leg";
import { packetErrorHandler } from "../../Utils/requestUtils";
import { NumericField } from "./KaminOrderForm";
import { kaminSettingsFields } from "./fields";

export default function KaminSettingsModal({ onClose, onSaved }: { onClose: () => void; onSaved: () => void }) {
  const [form] = Form.useForm<KaminSettings>();
  const [ready, setReady] = useState(false);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    let active = true;
    getKaminSettings().then(settings => {
      if (active) { form.setFieldsValue(settings); setReady(true); }
    }).catch(error => { if (active) packetErrorHandler(error); });
    return () => { active = false; };
  }, [form]);
  return <Modal title="تنظیمات کمین" modalBoxClassName="compact-confirm-modal border border-gray-200 shadow-xl"
    onClose={() => !busy && onClose()} UI={<FormBox className="!w-full !border-0 gap-3 !p-0">
      <div className="text-xs font-bold w-full border-b border-gray-200 pb-2">تنظیمات کمین</div>
      <div className="text-xs text-slate-500">این تنظیمات برای همه سفارش‌های کمین دولگ اعمال می‌شود.</div>
      <Form form={form} component={false} onFinish={async values => {
        const input = Object.fromEntries(kaminSettingsFields.map(field => [field.key,
          field.optional && (values[field.key] == null || String(values[field.key]).trim() === "")
            ? null : Number(values[field.key])])) as unknown as KaminSettings;
        setBusy(true);
        try { await saveKaminSettings(input); toast.success("تنظیمات کمین ذخیره شد"); onSaved(); onClose(); }
        catch (error) { packetErrorHandler(error); } finally { setBusy(false); }
      }}>
        {kaminSettingsFields.map(field => <Form.Item noStyle key={field.key} name={field.key}
          dependencies={field.key === "aheadFloorInsensitivityPercent" ? ["maxAheadFloorPercent"] : []}
          rules={[{ required: !field.optional, message: "مقدار لازم است" }, {
            validator: (_, value) => {
              if (field.optional && (value == null || String(value).trim() === "")) return Promise.resolve();
              const n = Number(value);
              if (!Number.isFinite(n) || n < field.min || n > field.max ||
                (field.integer ? !Number.isInteger(n) : !/^[+-]?\d+(\.\d{1,4})?$/.test(String(value))))
                return Promise.reject(new Error(field.integer ? "عدد صحیح در محدوده مجاز وارد کنید" : "درصد نامنفی با حداکثر چهار رقم اعشار وارد کنید"));
              const maximum = form.getFieldValue("maxAheadFloorPercent");
              return field.key === "aheadFloorInsensitivityPercent" && maximum != null && String(maximum).trim() !== "" && n > Number(maximum)
                ? Promise.reject(new Error("درصد بی‌حسی نباید از حداکثر حجم جلو کف بیشتر باشد")) : Promise.resolve();
            },
          }]}><NumericField name={field.key} label={field.label} integer={field.integer} disabled={!ready || busy} /></Form.Item>)}
        <Button variant="contained" text="ذخیره" disabled={!ready || busy} loading={busy} onClick={() => form.submit()} />
      </Form>
    </FormBox>} />;
}
